import { ViewObjectSettings } from "../view-object-settings";
import { ObjectCreator } from "../../../../../../web-graphics";

export class PlotSettings extends ViewObjectSettings {
  constructor(settings) {
    super(settings);

    for (const key of Object.getOwnPropertyNames(settings)) {
      if (key == "contentBorders") {
        const contentNames = [
          "topHeight",
          "bottomHeight",
          "leftWidth",
          "rightWidth",
          "topCentralHeight",
          "bottomCentralHeight",
          "leftCentralWidth",
          "rightCentralWidth"
        ];
        this.contentBorders = {};
        for (let i = 0; i < contentNames.length; i++) {
          let key = contentNames[i];
          this.contentBorders[key] = settings.contentBorders[key] === undefined ? undefined : settings.contentBorders[key].copy();
        }
      } else if (key == "plotContent") {
        this.plotContent = {};
        for (const key of Object.getOwnPropertyNames(settings.plotContent)) {
          let placedPlotContent = settings.plotContent[key];
          let placedPlotContentCopy = [];
          for (let contentIndex = 0; contentIndex < placedPlotContent.length; contentIndex++) {
            placedPlotContentCopy.push(placedPlotContent[contentIndex].copy()); // type: PlotContentSettings
          }
          this.plotContent[key] = placedPlotContentCopy;
        }
      } else if (key == "dataSources") {
        this.dataSources = [];
        for (let dataSourceIndex = 0; dataSourceIndex < settings.dataSources.length; dataSourceIndex++) {
          this.dataSources.push(settings.dataSources[dataSourceIndex].copy()); // type: DataSourcePlotSettings
        }
      } else {
        if (typeof settings[key] === "object" && settings[key].copy !== undefined) {
          this[key] = settings[key].copy();
        } else if (typeof settings[key] !== "function") {
          this[key] = ObjectCreator.deepCopy(settings[key]);
        }
      }
    }
  }

  copy() {
    return new PlotSettings(this);
  }
}
